import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import requestStatus from 'common/constants/status';

const initialFiltersState = {
  language: [],
  role: null
};

const initialState = {
  data: {
    currentLegal: null,
    legals: [],
    acceptance: null,
    acceptances: []
  },
  acceptStatus: requestStatus.idle,
  acceptancesStatus: requestStatus.idle,
  filters: initialFiltersState,
  pagination: {
    first: 20,
    page: 1
  },
  paginatorInfo: {
    hasMorePages: false,
    lastPage: 0,
    total: 0
  },
  refresh: false,
  status: requestStatus.idle
};

const legalSlice = createSlice({
  name: 'legal',
  initialState,
  reducers: {
    create(state) {
      state.status = requestStatus.loading;
    },
    createSuccess(state) {
      state.status = requestStatus.success;
    },
    createError(state) {
      state.status = requestStatus.error;
    },
    find(state) {
      state.status = requestStatus.loading;
    },
    findSuccess(state, action) {
      state.status = requestStatus.success;
      state.data.currentLegal = action.payload;
    },
    findError(state) {
      state.status = requestStatus.error;
    },
    forceDelete(state) {
      state.status = requestStatus.loading;
    },
    forceDeleteSuccess(state) {
      state.status = requestStatus.success;
      state.refresh = true;
    },
    forceDeleteError(state) {
      state.status = requestStatus.error;
    },
    getLatestByRole(state) {
      state.status = requestStatus.loading;
    },
    getLatestByRoleSuccess(state, action) {
      state.status = requestStatus.success;
      state.data.currentLegal = action.payload;
    },
    getLatestByRoleError(state) {
      state.status = requestStatus.error;
    },
    getMyAcceptance() {},
    getMyAcceptanceSuccess(state, action) {
      state.data.acceptance = action.payload;
    },
    getMyAcceptanceError(state) {
      state.data.acceptance = null;
    },
    accept(state) {
      state.acceptStatus = requestStatus.loading;
    },
    acceptSuccess(state, action) {
      state.acceptStatus = requestStatus.success;
      state.data.acceptance = action.payload;
    },
    acceptError(state) {
      state.acceptStatus = requestStatus.error;
    },
    clearAcceptance(state) {
      state.data.acceptance = null;
      state.acceptStatus = requestStatus.idle;
    },
    getAcceptances(state) {
      state.acceptancesStatus = requestStatus.loading;
    },
    getAcceptancesSuccess(state, action) {
      state.acceptancesStatus = requestStatus.success;
      state.data.acceptances = action.payload;
    },
    getAcceptancesError(state) {
      state.acceptancesStatus = requestStatus.error;
      state.data.acceptances = [];
    },
    list(state) {
      state.status = requestStatus.loading;
      if (state.refresh) state.refresh = false;
    },
    listSuccess(state, action) {
      state.status = requestStatus.success;
      state.data.legals = action.payload;
    },
    listError(state) {
      state.status = requestStatus.error;
    },
    resetFilters(state) {
      state.filters = initialFiltersState;
    },
    update(state) {
      state.status = requestStatus.loading;
    },
    updateSuccess(state) {
      state.status = requestStatus.success;
    },
    updateError(state) {
      state.status = requestStatus.error;
    },
    updateFilters(state, action) {
      state.filters = action.payload;
    },
    updatePagination(state, action) {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    updatePaginatorInfo(state, action) {
      state.paginatorInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default legalSlice;
